// gatsby-browser.js
import "./src/styles/global.css"
import React from "react"
import { HelmetProvider } from "react-helmet-async"

// Wrap the root for react-helmet-async
export const wrapRootElement = ({ element }) => {
  return <HelmetProvider>{element}</HelmetProvider>
}
